import { render, staticRenderFns } from "./UserDashboardFacilitiesHelps.vue?vue&type=template&id=fc100c52&scoped=true&"
import script from "./UserDashboardFacilitiesHelps.vue?vue&type=script&lang=js&"
export * from "./UserDashboardFacilitiesHelps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc100c52",
  null
  
)

export default component.exports